import React from 'react';
import { isPresentInArray } from '../../../../../itrust_common/components/HelperFunctions';
import LensView from './LensView';
import OldValuesHeader from '../../oldValues/OldValuesHeader';

const ContactLens = ({ fieldsValues, template, handleIdsSelect, selectedIds, overviewName, previousExams, fieldKey, examId }) => {
  if (previousExams) {
    return previousExams
      .filter((exam) => exam.id !== examId)
      .flatMap((prevExam) =>
        (prevExam?.[fieldKey] || [])
          .filter((lens) => lens.is_marked_complete)
          .map((lens, index) => (
            <div className="col-12 border rounded mb-4 px-0" key={`${prevExam.id}-${lens.id || index}`}>
              <div className="row mx-0">
                <OldValuesHeader
                  prevExam={prevExam}
                  overviewName={overviewName}
                  examId={examId}
                  importIds={lens.id ? [lens.id] : []}
                  importSourceLenses={[lens]}
                />
                <div className="col-12 py-4">
                  <LensView fieldsValues={lens} template={template} />
                </div>
              </div>
            </div>
          ))
      );
  }

  return (
    <div className="row">
      {fieldsValues?.map((lens, index) =>
        lens.is_marked_complete && (
          <div className={`col-12 ${index !== 0 ? 'py-4' : 'pb-4'}`} key={lens.id || index}>
            <div className="d-flex justify-content-between">
              {overviewName && handleIdsSelect && (
                <div className="d-flex">
                  <label className="mr-3">Select</label>
                  <div className="custom-control custom-checkbox">
                    <input
                      onChange={() => handleIdsSelect(selectedIds, lens.id)}
                      type="checkbox"
                      checked={isPresentInArray(selectedIds, lens.id)}
                      className="custom-control-input"
                      id={`impression-select-${lens.id}`}
                    />
                    <label className="custom-control-label" htmlFor={`impression-select-${lens.id}`} />
                  </div>
                </div>
              )}
            </div>
            <LensView fieldsValues={lens} template={template} />
          </div>
        )
      )}
    </div>
  );
};

export default ContactLens;
